// Message code define


// Endpoint
export const TeamActivityPoint = {
  CREATE: 'admin/team-activity-event/create',
  UPDATE: 'admin/team-activity-event/update',
  DELETE: 'admin/team-activity-event/delete',
}